module.exports = __webpack_public_path__ + "img/galery1.20e061fe.jpg";